import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { trackEvent } from './MetaPixel';
interface ButtonProps {
  children: React.ReactNode;
  isCheckout?: boolean;
  className?: string;
}
export const smoothScrollTo = (targetId: string, duration: number) => {
  const target = document.getElementById(targetId);
  if (!target) return;
  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;
  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };
  const ease = (t: number, b: number, c: number, d: number) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };
  requestAnimationFrame(animation);
};
export function Button({
  children,
  isCheckout = false,
  className = ''
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (isCheckout) {
      trackEvent('InitiateCheckout');
      window.location.href = 'https://checkout.ecompradigital.online/cart/46151807369404:1';
    } else {
      e.preventDefault();
      trackEvent('Lead');
      smoothScrollTo('oferta', 800);
    }
  };
  return <div className={`flex flex-col items-center w-full max-w-md mx-auto ${className}`} data-id="element-54">
      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={handleClick} className="w-full bg-gradient-to-r from-rosa to-terracota text-white font-bold text-lg md:text-xl py-3 md:py-4 px-6 md:px-8 rounded-full shadow-[0_0_20px_rgba(217,108,138,0.5)] hover:shadow-[0_0_30px_rgba(201,123,99,0.8)] transition-shadow duration-300 uppercase tracking-wide" data-id="element-55">
        {children}
      </motion.button>
      <div className="flex items-center gap-1 mt-2 text-[10px] md:text-xs text-gray-400" data-id="element-56">
        <ShieldCheck size={14} className="text-terracota" data-id="element-57" />
        <span data-id="element-58">Compra protegida por Mercado Pago</span>
      </div>
    </div>;
}